import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import BlockGradTemplate from 'app/components/DesignVersion/Grad/Blocks/BlockGradTemplate';

import PlayerStats from './PlayerStats';
import { getOpponentsPlayerStatData } from './utils';
import style from './style.module.scss';

interface Props {
  data: PlayersStatsBlockMatch;
}

const PlayersStatsBlockGrad: FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const [opponent1PlayersStats, opponent2PlayersStats] = getOpponentsPlayerStatData(data);

  return (
    <BlockGradTemplate
      hasData={data.opponents.some(
        opponent => opponent?.stats && Object.values(opponent.stats.players)?.length
      )}
      contentClassName={style.playerStatsContent}
    >
      {opponent1PlayersStats.length > 0 ? (
        <ul className={style.teamPlayers}>
          {opponent1PlayersStats.map((player, index) => (
            <PlayerStats key={`team1_player_${index}`} playerStats={player} teamNumber={1} />
          ))}
        </ul>
      ) : (
        <div className={style.noPlayers}>{t('error_no-data_compact')}</div>
      )}
      {opponent2PlayersStats.length > 0 ? (
        <ul className={style.teamPlayers}>
          {opponent2PlayersStats.map((player, index) => (
            <PlayerStats key={`team2_player_${index}`} playerStats={player} teamNumber={2} />
          ))}
        </ul>
      ) : (
        <div className={style.noPlayers}>{t('error_no-data_compact')}</div>
      )}
    </BlockGradTemplate>
  );
};

PlayersStatsBlockGrad.displayName = 'PlayersStatsBlockGrad';

export default PlayersStatsBlockGrad;
